export function ProductLineService($http, apexApiUrl) {
    'ngInject';
    return {
        createProductLines: createProductLines,
        retrieveProductLines: retrieveProductLines,
        updateProductLine: updateProductLine,
        deleteProductLine: deleteProductLine,
        getRogersCategories: getRogersCategories
    };

    function retrieveProductLines() {
        return $http({
            method: "GET",
            url: apexApiUrl + "product-lines",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    function createProductLines(data) {

        return $http({
            method: "POST",
            data: data,
            url: apexApiUrl + "product-lines",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateProductLine(id, productLine) {

        return $http({
            method: "PUT",
            url: apexApiUrl + "product-lines/" + id,
            data: productLine

        });
    }

    function deleteProductLine(id) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "product-lines/" + id
        });
    }

    function getRogersCategories() {
        return [
            {
                CategoryID: 1,
                CategoryDescription: "TV"
            },
            {
                CategoryID: 2,
                CategoryDescription: "Internet"
            },
            {
                CategoryID: 3,
                CategoryDescription: "Home Phone"
            },
            {
                CategoryID: 4,
                CategoryDescription: "Smart Home Monitoring"
            },
            {
                CategoryID: 5,
                CategoryDescription: "Wireless"
            },
            {
                CategoryID: 6,
                CategoryDescription: "Content"
            },
            {
                CategoryID: 7,
                CategoryDescription: "Migration"
            }
        ].sort((a, b) => a.text < b.text ? -1 : 1);
    }
}
